import { CheatGUI } from 'core/GUI/CheatGUI'
import { GUI } from 'dat.gui'
import { gsap } from 'gsap'
import { signal } from 'services/SignalsService'
import { date, debug, hash } from 'settings/custom/build'

export default class DatGUI extends GUI {
  constructor() {
    super({ hideable: debug ? true : false })
    this.global = {
      'Hash': hash,
      'Deploy Date': date,
      'timeScale': 1,
      'Reset Time': () => {},
    }
    this.folders = {}
    this.controllers = {}
    this.include = this.addFolder('Include')
    this.createGlobal()

    debug
      ? this.cheat = new CheatGUI()
      : this.hide()

    this.hide()
    signal.on('TOGGLE:cheat', (value) => {
      value ? this.show() : this.hide()
    })
  }

  /**
   * Add new GUI setting, with folder or not
   * @param {object} obj
   * Object with property which will be changed
   *
   * @param {string} property
   * Property which will be changed
   *
   * @param {object} options
   * { min, max, step }
   *
   * @param {callback} callback
   * Function to call after complete
   *
   * @param {string} folder
   * name of folder where need to add setting
   */
  create(obj, property, options, callback, folder) {
    const { min, max, step } = options

    this.controllers[property] = folder ? withFolder.call(this) : this.add(obj, property, min, max, step)

    this.controllers[property].onChange(callback)

    function withFolder() {
      if(this.folders[folder]) {
        return this.folders[folder].add(obj, property, min, max, step)
      }
      else {
        this.folders[folder] = this.addFolder(folder)
        return this.folders[folder].add(obj, property, min, max, step)
      }
    }
  }

  createGlobal() {
    this.create(this.global,
      'Hash',
      {},
      () => {
      },
      'Global',
    )
    this.create(this.global,
      'Deploy Date',
      {},
      () => {
      },
      'Global',
    )
    this.create(this.global,
      'timeScale',
      { min: 0, max: 30 },
      (value) => {
        signal.dispatch('ANIMATION:TIME-SCALE', value)
        gsap.globalTimeline.timeScale(this.global.timeScale)
      },
      'Global',
    )
    this.create(
      this.global,
      'Reset Time',
      {},
      () => {
        this.controllers.timeScale.setValue(1)
      },
      'Global',
    )
  }
}
